/**
 * Admin-API: 1:1-Chat zwischen Members (Sales › Team).
 * Endpunkte:
 *   GET  /api/admin/members/:id/messages?after=<unix_ts>&limit=<n>
 *   POST /api/admin/members/:id/messages   { content }
 */

function authHeaders(token) {
  return { Authorization: "Bearer " + (token || "") };
}

export async function listMessages({ apiBase, token, peerId, after, limit }) {
  const params = new URLSearchParams();
  if (after != null && Number.isFinite(Number(after))) {
    params.set("after", String(Math.floor(Number(after))));
  }
  if (limit != null && Number.isFinite(Number(limit))) {
    params.set("limit", String(Math.floor(Number(limit))));
  }
  const qs = params.toString();
  const url =
    `${apiBase}/api/admin/members/${peerId}/messages` +
    (qs ? `?${qs}` : "");
  const r = await fetch(url, { headers: authHeaders(token) });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || "Nachrichten konnten nicht geladen werden");
  return Array.isArray(j.messages) ? j.messages : [];
}

export async function sendMessage({ apiBase, token, peerId, content }) {
  const r = await fetch(`${apiBase}/api/admin/members/${peerId}/messages`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeaders(token) },
    body: JSON.stringify({ content }),
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || "Senden fehlgeschlagen");
  return j.message || null;
}
